import { render } from "./payType.vue?vue&type=template&id=34ad59b2&scoped=true"
import script from "./payType.vue?vue&type=script&lang=js"
export * from "./payType.vue?vue&type=script&lang=js"

import "./payType.vue?vue&type=style&index=0&id=34ad59b2&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ad59b2"]])

export default __exports__